import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { fetchBuyCarMenuPcCondition } from "@Services/buyCarMenu";
import { IBuyCarMenuPcCondition } from "@Types/buyCarMenu";
import RegionItem from "@Components/menu/RegionItem";
import ColorList from "@Components/menu/ColorList";
import InsuranceList from "@Components/menu/InsuranceList";
import PaymentTypeList from "@Components/menu/PaymentTypeList";
import BrandList from "@Components/menu/BrandList";
import { message } from "antd";
import PressCondition from "./PressCondition";
import qs from "qs";
import { useSetState, useUpdateEffect } from "ahooks";
import KindCondition from "./KindCondition";

const initData: IBuyCarMenuPcCondition = {
  autoType: [],
  allBrand: [],
  brand: [],
  color: [],
  insurance: [],
  kind: [],
  paymentType: [],
  price: [],
  region: [],
};

function countPrice({ minRef, maxRef }) {
  let $minRefValue = minRef.current.value;
  let $maxRefValue = maxRef.current.value;

  let min = Number($minRefValue);
  let max = Number($maxRefValue);

  if (!!$minRefValue && !!$maxRefValue) {
    min = Math.min($minRefValue, $maxRefValue);
    max = Math.max($minRefValue, $maxRefValue);
  }

  return {
    min,
    max,
  };
}

const LabelItem: React.FC<any> = ({ name }) => {
  return (
    <div
      className='w-90 bg-[#F0F6FF] text-14 px-18 whitespace-pre'
      style={{ textAlignLast: "justify", lineHeight: "46px" }}
    >
      {name}
    </div>
  );
};

const Item: React.FC<any> = ({ data, action, onChange, name }) => {
  return (
    <>
      {data.map((item, index: number) => (
        <div
          className={`${
            action === `${item.value}` ? "bg-[#4364FF] text-white" : ""
          } cursor-pointer px-6  rounded-4 h-30 flex items-center justify-center  select-none`}
          key={index}
          onClick={() => {
            onChange(item, { value: item.field, name: name });
          }}
        >
          {item.enName || item.name}
        </div>
      ))}
    </>
  );
};

const PriceItem: React.FC<any> = ({ data, action, onChange }) => {
  const minRef = useRef<HTMLInputElement>(null);
  const maxRef = useRef<HTMLInputElement>(null);

  const [count, setCount] = useSetState({
    min: "",
    max: "",
  });

  useEffect(() => {
    let $minRef = minRef.current;
    let $maxRef = maxRef.current;

    if ($minRef !== null) {
      $minRef?.addEventListener("input", function (e) {
        $minRef.value = $minRef.value.replace(/[^0-9]/g, "");
        setCount({ min: $minRef.value });
      });

      $minRef?.addEventListener("paste", function (e) {
        const paste = (e.clipboardData || window.clipboardData).getData("text");
        if (!/^\d+$/.test(paste)) {
          e.preventDefault();
        }
      });
    }
    if ($maxRef !== null) {
      $maxRef?.addEventListener("input", function (e) {
        $maxRef.value = $maxRef.value.replace(/[^0-9]/g, "");
        setCount({ max: $maxRef.value });
      });

      $maxRef?.addEventListener("paste", function (e) {
        const paste = (e.clipboardData || window.clipboardData).getData("text");
        if (!/^\d+$/.test(paste)) {
          e.preventDefault();
        }
      });
    }
  }, []);

  useEffect(() => {
    const isPrice = data.some((item) => item.value === action);
    let $minRef = minRef.current;
    let $maxRef = maxRef.current;
    if ($minRef && $maxRef) {
      if (!isPrice && !!action) {
        const [min, max] = action.split("-");

        $minRef.value = min;
        $maxRef.value = max === "999999" ? "" : max;
      } else {
        $minRef.value = "";
        $maxRef.value = "";
      }
    }
  }, [action]);

  return (
    <div className='flex items-center gap-8'>
      {data.map((item, index: number) => (
        <div
          data-price={item.name}
          id='PriceItem'
          className={`${
            action === `${item.value}` ? "bg-[#4364FF] text-white" : ""
          } cursor-pointer px-6  rounded-4 h-30 flex items-center justify-center `}
          key={index}
          onClick={() => {
            onChange(item, { value: "price", name: "priceName" });
          }}
        >
          {item.name}
        </div>
      ))}
      <div className='flex items-center gap-10'>
        <input
          ref={minRef}
          type='text'
          className='w-50 h-24 rounded-4  text-center text-12'
          style={{ border: "1px solid #BBB" }}
        />
        至
        <input
          ref={maxRef}
          type='text'
          className='w-50 h-24 rounded-4  text-center text-12'
          style={{ border: "1px solid #BBB" }}
        />
        萬
        <div
          id='PriceItem'
          className='text-14 flex justify-center items-center cursor-pointer rounded-4'
          data-price={`${count.min}-${count.max}萬`}
          onClick={() => {
            const { min, max } = countPrice({ minRef, maxRef });
            if (!min && !max) {
              message.info("請填寫價格");
              return;
            }
            if (min === 0 && max === 0) {
              message.info("請填寫正確的價格");
              return;
            }
            onChange(
              {
                field: "price",
                name: `${min}-${max === 0 ? "999999" : max}萬`,
                value: `${min}-${max === 0 ? "999999" : max}`,
              },
              { value: "price", name: "priceName" },
            );
          }}
          style={{ border: "1px solid #d5d5d5", width: "60px", height: "24px", backgroundColor: "#f7f7f7" }}
        >
          確認
        </div>
      </div>
    </div>
  );
};

function matchedFields({ pattern, query, params }) {
  let queryMerge = { ...query };
  if (!!window.query_kind_id) {
    queryMerge.kindId = window.query_kind_id;
  }
  if (!!window.query_kind_name) {
    queryMerge.kindIdName = window.query_kind_name;
  }

  if (!!window.query_brand_id) {
    queryMerge.brandId = window.query_brand_id;
  }
  if (!!window.query_brand_name) {
    queryMerge.brandIdName = window.query_brand_name;
  }

  const regex = new RegExp(pattern);
  const matchedKeys = Object.keys(queryMerge).filter((key) => regex.test(key));

  const matchedFields = matchedKeys.reduce((result, key) => {
    result[key] = queryMerge[key];
    return result;
  }, {});

  if (Object.keys(matchedFields).length === 0) {
    return null;
  }

  params[pattern] = matchedFields[pattern];
  params[`${pattern}Name`] = matchedFields[`${pattern}Name`];

  let value = matchedFields[pattern];

  return {
    name: matchedFields[`${pattern}Name`],
    enName: matchedFields[`${pattern}Name`],
    value: value,
    field: pattern,
  };
}

function filterOrders({ query, setParams }) {
  let { sort = "postDate-desc", type = "" } = qs.parse(location.search, { ignoreQueryPrefix: true });
  let orders: any = [];
  let ob: any = {};
  let params: any = {};

  ob = matchedFields({ pattern: "brandId", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "kindId", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "price", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "autoType", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "regionId", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "color", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "insurance", query, params });
  !!ob && orders.push(ob);
  ob = matchedFields({ pattern: "paymentType", query, params });
  !!ob && orders.push(ob);

  setParams({ ...params, orders, sort, type });
}

const FilterCondition: React.FC<any> = ({ onChange, params, setParams, onClear }) => {
  let query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [show, setShow] = useState<"region" | "color" | "paymentType" | "insurance" | "">("");
  const { kindId, sort, brandId, autoType, price, regionId, orders, color, insurance, paymentType } = params;

  const { data = initData, refetch } = useQuery<IBuyCarMenuPcCondition>(
    [`fetchBuyCarMenuPcCondition`],
    async () => {
      const res = await fetchBuyCarMenuPcCondition({ brandId, kindId });
      return res?.status === 12000 ? res.data : initData;
    },
    {
      enabled: !!sort,
    },
  );

  useUpdateEffect(() => {
    refetch();
  }, [brandId, kindId]);

  useEffect(() => {
    // 过滤url参数,重构orders
    filterOrders({ query, setParams });
  }, []);

  useEffect(() => {
    // 定义点击事件处理函数
    const handleClick = (event) => {
      setShow("");
    };
    // 添加全局点击事件监听器
    document.addEventListener("click", handleClick);

    // 在组件卸载时移除事件监听器
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <>
      {data.allBrand.length > 0 && (
        <div id='FilterCondition' className='text-14 text-black bg-white'>
          <div className='bg-white rounded-4' style={{ border: "1px solid #E8E8E8" }}>
            {/* 你已经選擇 */}
            {orders.length > 0 && (
              <PressCondition
                data={data}
                params={params}
                setParams={(params) => {
                  onClear?.();
                  setParams(params);
                }}
                refetch={refetch}
              />
            )}

            {/* 廠牌条件 */}
            <BrandList data={data} onChange={onChange} params={params} />

            {/* 车款条件 */}
            <KindCondition
              allBrand={data.allBrand}
              kind={data.kind}
              brandId={params.brandId}
              onChange={onChange}
              params={params}
              kindId={kindId}
            />

            <div className='flex gap-12' id='autoTypeName'>
              <LabelItem name='級距' />
              <div className='flex gap-8 items-center w-800 flex-wrap'>
                {data.autoType.length > 0 && (
                  <Item onChange={onChange} action={autoType} data={data.autoType} name='autoTypeName' />
                )}
              </div>
            </div>
            <div className='flex gap-12' id='price'>
              <LabelItem name='價格' />
              <div className='flex gap-8 items-center w-800 flex-wrap'>
                {data.price.length > 0 && <PriceItem onChange={onChange} data={data.price} action={price} />}
              </div>
            </div>
            <div className='flex gap-20'>
              <LabelItem name='其他' />
              <div className='flex gap-20 items-center w-200 whitespace-pre'>
                <RegionItem
                  action={regionId}
                  show={show}
                  setShow={setShow}
                  data={data.region}
                  onClick={(e) => {
                    setShow("");
                    onChange(e, { value: "regionId", name: "regionIdName" });
                  }}
                />
                <ColorList
                  action={color}
                  show={show}
                  setShow={setShow}
                  data={data.color}
                  onClick={(e) => {
                    setShow("");
                    onChange(e, { value: "color", name: "colorName" });
                  }}
                />
                <InsuranceList
                  action={insurance}
                  show={show}
                  setShow={setShow}
                  data={data.insurance}
                  onClick={(e) => {
                    setShow("");
                    onChange(e, { value: "insurance", name: "insuranceName" });
                  }}
                />
                <PaymentTypeList
                  show={show}
                  setShow={setShow}
                  action={paymentType}
                  data={data.paymentType}
                  onClick={(e) => {
                    setShow("");
                    onChange(e, { value: "paymentType", name: "paymentTypeName" });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterCondition;
